module.exports = __webpack_public_path__ + "img/15_11.8c8f29d7.png";